import { csmCustomerContextTenantMigratedStatusResource } from '@jira/jira-router-resources-service-desk-customers-organizations-common/src/services/index.tsx';
import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { AsyncDirectoryNav } from '@atlassian/jira-horizontal-nav-jsm-directory/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarServicedesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { servicedeskCustomersV2Route } from '@atlassian/jira-router-routes-servicedesk-customers-routes/src/servicedeskCustomersV2Route.tsx';

import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { ServiceDeskContacts } from './ui/index.tsx';

export const servicedeskCustomersV2RouteEntry = createEntry(servicedeskCustomersV2Route, () => ({
	group: 'servicedesk',
	layout: serviceProjectLayout,

	resources: [
		...getServiceDeskNavigationResources(),
		...getServicedeskPageContextResources(),
		getConsolidationStateResource(),
		csmCustomerContextTenantMigratedStatusResource,
	],

	component: ServiceDeskContacts,
	forPaint: [LazyAtlassianNavigation],
	perfMetricKey: 'jsm-customers-component-load',
	ufoName: 'jsm-customers-component-load',

	navigation: {
		menuId: MENU_ID.PROJECTS,
		sidebar: AsyncSidebarServicedesk,
		horizontal: AsyncDirectoryNav,
		// TODO: Remove this during jira_nav4 cleanup
	},

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-servicedesk-customers-entries/src/servicedeskCustomersV2RouteEntry.tsx',
			whichExportToUse: 'servicedeskCustomersV2RouteEntry',
		},

		enabled: true,
	},
}));
